
// src/Utils/validateForm.js

// 🟢 Helpers مشتركة لتجنب التكرار
function isValidSyrianPhone(phone) {
  return /^09\d{8}$/.test(phone);
}

function getPhoneError(phone) {
  return isValidSyrianPhone(phone)
    ? ""
    : "رقم الموبايل يجب أن يبدأ بـ 09 وطوله 10 أرقام فقط";
}

function getPasswordError(password, minLength = 8) {
  if (!password || password.length < minLength) {
    return `كلمة السر يجب أن تكون ${minLength} أحرف على الأقل`;
  }
  return "";
}

function getPasswordConfirmationError(password, confirmation) {
  if (password !== confirmation) {
    return "كلمتا السر غير متطابقتين";
  }
  return "";
}

// 🟢 التحقق من إدخال الهاتف أثناء الكتابة
export function handlePhoneInputKeyPress(e, value) {
  if (!/[0-9]/.test(e.key)) e.preventDefault();          // منع الأحرف غير الرقمية
  if (value.length >= 10) e.preventDefault();            // منع أكثر من 10 أرقام
  if (value.length === 0 && e.key !== "0") e.preventDefault();
  if (value.length === 1 && (value[0] !== "0" || e.key !== "9"))
    e.preventDefault();
}




// 🟢 نموذج التسجيل
export function validateRegisterForm(values) {
  const errors = {};

  if (!values.first_name?.trim()) errors.first_name = "الاسم الأول مطلوب";
  if (!values.father_name?.trim()) errors.father_name = "اسم الأب مطلوب";
  if (!values.last_name?.trim()) errors.last_name = "الكنية مطلوبة";
  if (!values.governorate_name?.trim()) errors.governorate_name = "المحافظة مطلوبة";
  if (!values.national_id?.trim()) errors.national_id = "الرقم الوطني مطلوب";
  if (!values.super_admin_secret?.trim()) errors.super_admin_secret = "رمز المشرف العام مطلوب";

  const phoneError = getPhoneError(values.phone_number);
  if (phoneError) errors.phone_number = phoneError;

  const passwordError = getPasswordError(values.password, 8);
  if (passwordError) errors.password = passwordError;

  const confirmError = getPasswordConfirmationError(
    values.password,
    values.password_confirmation
  );
  if (confirmError) errors.password_confirmation = confirmError;

  return errors;
}

// 🟢 نموذج تسجيل الدخول
export function validateLoginForm(values) {
  const errors = {};

  const phoneError = getPhoneError(values.phone_number);
  if (phoneError) errors.phone_number = phoneError;

  const passwordError = getPasswordError(values.password, 8);
  if (passwordError) errors.password = passwordError;

  return errors;
}

// 🟢 التحقق الفوري لرقم الموبايل أثناء الكتابة
export function getInstantPhoneError(value) {
  if (value !== "" && !/^09\d{0,8}$/.test(value)) {
    return "رقم الموبايل يجب أن يبدأ بـ 09 وطوله 10 أرقام فقط";
  }
  return "";
}



// 🟢 إعادة تعيين كلمة السر
export function validateResetPasswordForm(values) {
  const errors = {};

  const passwordError = getPasswordError(values.password, 8);
  if (passwordError) errors.password = passwordError;

  if (!values.password_confirmation) {
    errors.password_confirmation = "يرجى تأكيد كلمة السر";
  } else {
    const confirmError = getPasswordConfirmationError(
      values.password,
      values.password_confirmation
    );
    if (confirmError) errors.password_confirmation = confirmError;
  }

  return errors;
}

// 🟢 تغيير كلمة السر
export function validateChangePasswordForm(fields) {
  const errors = {};

  if (!fields.old_password) errors.old_password = "كلمة المرور الحالية مطلوبة";

  const newPassError = getPasswordError(fields.new_password, 8);
  if (newPassError) errors.new_password = newPassError;

  const confirmError = getPasswordConfirmationError(
    fields.new_password,
    fields.confirm_password
  );
  if (confirmError) errors.confirm_password = confirmError;

  return errors;
}

// 🟢 نموذج إضافة إحالة
export function validateReferralForm(values) {
  const errors = {};
  const phoneError = getPhoneError(values.referrer_phone);
  if (phoneError) errors.referrer_phone = phoneError;
  return errors;
}

//////////////////////////////////////////////////////////////

export default function validateWalletTransferForm(values) {
  const errors = {};

  // ✅ تحقق من رقم الهاتف
//   // التحقق من الهاتف
  const phoneError = getPhoneError(values.phone_number);
  if (phoneError) {
    errors.phone_number = phoneError;
  }
  
  // ✅ تحقق من المبلغ
  if (!values.amount_sp) {
    errors.amount_sp = 'المبلغ مطلوب';
  } else if (isNaN(values.amount_sp) || parseFloat(values.amount_sp) <= 0) {
    errors.amount_sp = 'الرجاء إدخال مبلغ صالح';
  }

  // ✅ تحقق من المبلغ المدفوع إذا كان دين
  if (values.is_debt) {
    if (!values.amount_paid) {
      errors.amount_paid = 'المبلغ المدفوع مطلوب عند تحديد دين';
    } else if (isNaN(values.amount_paid) || parseFloat(values.amount_paid) < 0) {
      errors.amount_paid = 'الرجاء إدخال مبلغ مدفوع صالح';
    } else if (parseFloat(values.amount_paid) > parseFloat(values.amount_sp)) {
      errors.amount_paid = 'المبلغ المدفوع لا يمكن أن يكون أكبر من المبلغ الكلي';
    }
  }

  return errors;
}


//////////////////////////////////////////////////


